import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=22db9d6e"
import script from "./confirmPayment.vue?vue&type=script&lang=js"
export * from "./confirmPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports